import React, { useRef } from 'react';
import {
  Autocomplete,
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  AutocompleteOwnerState,
  AutocompleteRenderOptionState,
  TextField
} from '@mui/material';
import './_styles.scss';
import { classNameBuilder, isObject } from '../../utilities';
import useStateReducer from '../../hooks/useStateReducer';
import { paginate } from '../../utilities/arrayUtils';

interface IListProps {
  label?: string;
  error?: boolean;
  getOptionValue?(option: any): any;
  value?: any;
  className?: string;
  id?: string;
  onChange?: (
    event: React.SyntheticEvent<Element, Event>,
    value: any,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<any> | undefined
  ) => void;
  disabled?: boolean;
  readOnly?: boolean;
  options: any[];
  getOptionDisabled?: (option: any) => boolean;
  getOptionLabel?: (option: any) => string;
  getOptionValue?: (option: any) => any;
  isOptionEqualToValue?: (option: any, value: any) => boolean;
  multiple?: boolean;
  groupBy?: (option: any) => string;
  renderOption?:
    | ((
        props: React.HTMLAttributes<HTMLLIElement>,
        option: any,
        state: AutocompleteRenderOptionState,
        ownerState?: AutocompleteOwnerState<any, boolean, false, false, 'div'>
      ) => React.ReactNode)
    | undefined;
}

export default function List({
  label,
  value,
  className,
  id,
  onChange,
  error,
  disabled,
  readOnly,
  options,
  getOptionDisabled,
  getOptionLabel,
  getOptionValue,
  isOptionEqualToValue,
  multiple,
  groupBy,
  renderOption
}: IListProps) {
  const PAGE_SIZE = 10;
  const TOTAL_PAGES = Math.ceil([...options].length / PAGE_SIZE);
  const PAGE_NUMBER = 1;
  const DEBOUNCE_DELAY = 650;

  const scrollRef = useRef<HTMLDivElement>(null);
  const [state, setState] = useStateReducer({
    partnerLinks: paginate(options, PAGE_SIZE, PAGE_NUMBER),
    loading: false,
    searchList: [...options],
    isSearch: false,
    scrollTo: null
  });

  let val;

  if (!value) val = null;
  else if (isObject(value)) val = value;
  else if (getOptionValue)
    val = options.filter((o) => getOptionValue(o) === value);
  return (
    <Autocomplete
      id={id}
      className={classNameBuilder(
        'h-app-autocomplete-field',
        readOnly ? 'readonly' : '',
        className ?? ''
      )}
      onChange={onChange}
      value={val}
      disabled={disabled}
      readOnly={readOnly}
      options={options}
      getOptionDisabled={getOptionDisabled}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      isOptionEqualToValue={(o, v) => v && isOptionEqualToValue?.(o, v)}
      multiple={multiple}
      groupBy={groupBy}
      size='small'
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          autoComplete='new-password'
          error={error}
          className={'test'}
        />
      )}
    />
  );
}
